// axios
import request from '@/utils/request';
import { store } from '@/store/index.ts';

/* 书详情接口 */
export const API = {
  bookDetail:
    '/webApi/book/getBookInfoById' /* 书架列表  ObjectType 内容类型：1专题 53-图书，54-有声书，55-视频，64-条目文档 */,
  menuList: '/webApi/book/getBookCatalog' /* 书单 */,
  getBookCatalogForRead: '/webApi/book/getBookCatalogForRead', /* 阅读书单 */
  resourceList: '/webApi/book/getBookAdditional' /* 附加资源 */,
  pushList:
    '/webApi/book/getBookRelevantRecommendations' /* 获取相关推荐 */,
  newPushList:
    '/webApi/correlation/list2correlation' /* 获取相关推荐 */,
  serach: '/webApi/book/searchBookList' /* 搜索电子书 */,
  bookListBySpecil:
    '/webApi/book/getBookListBySubIdObjectType' /* 根据专题id 查询图书列表 分页 */,
  newBooks: '/webApi/book/bookNews' /* 新品推荐 */,
  dicList: '/webApi/dictData/getInfo' /* 查询字典数据 */,
  topClick:
    '/webApi/book/clickThroughRate' /* 点击根据点击率获取电子书资源 */,
  userRead: '/webApi/userRead/userRead' /* 阅读的时候调用下 */,
  readHeart: '/webApi/userBookRead/readHeart' /* 阅读心跳 */,
  overRead: '/webApi/userBookRead/overRead' /* 完播接口 */,
  yearRange: '/webApi/book/getSearchDate' /* 查询电子书时间范围 */,
  playList:
    '/webApi/userRead/getUserReadList' /* 用户已读列表 用于最近播放 */,
  getBookCatalogueInfo: '/webApi/book/getBookCatalogueInfo',
  getBookCountByType: '/webApi/book/getBookCountByType',
  getCountBook: '/webApi/book/getCountBook',

  addReadNum: `/webApi/book/addReadNum`,
  addSpecialNum: `/webApi/special/addReadNum`,
  getPlatformIsRecommendApi: `/webApi/platformConfig/getPlatformIsRecommend`,
  getNumBookTypeApi: `/webApi/book/getNumBookType`,
  // 添加记录
  addBookRecordApi: `/webApi/book/addBookRecord`,
  getSpecialSubjectSearchList: `/webApi/special/tSpecialSubjectSearchList`,
};

/* 是否开启榜单推荐功能 */
export function getNumBookTypeApi (data) {
  return request({
    url: API.getNumBookTypeApi,
    method: 'get',
    params: data,
  });
}

/* 是否开启榜单推荐功能 */
export function getPlatformIsRecommendApi (data) {
  // userRead({ resourceId: data.id, resourceType: 54 });
  return request({
    url: API.getPlatformIsRecommendApi,
    method: 'get',
    params: data,
  });
}

/* 根据id查询详情 */
export function getInfoById (data) {
  // userRead({ resourceId: data.id, resourceType: 54 });
  return request({
    url: API.bookDetail,
    method: 'get',
    params: data,
  });
}

/* 添加阅读量 */
export function addReadNum (data) {
  return request({
    url: API.addReadNum,
    method: 'post',
    params: data,
  });
}

/* 添加专题阅读量 */
export function addSpecialNum (data) {
  return request({
    url: API.addSpecialNum,
    method: 'post',
    params: data,
  });
}

/* 根据书id查询目录 */
export function getMenuByBookId (data) {
  return request({
    url: API.menuList,
    method: 'get',
    params: data,
  });
}

/* 根据书id查询已排序目录 */
export function getBookCatalogForRead (data) {
  return request({
    url: API.getBookCatalogForRead,
    method: 'get',
    params: data
  });
}

/* 根据书id查询附加资源 */
export function getResouceByBookId (data) {
  return request({
    url: API.resourceList,
    method: 'get',
    params: data,
  });
}

/* 根据书id查询推荐资源  新 */
export function newGetPushByBookId (data) {
  return request({
    url: API.newPushList,
    method: 'get',
    params: data,
  });
}

/* 根据书id查询推荐资源 */
export function getPushByBookId (data) {
  return request({
    url: API.pushList,
    method: 'get',
    params: data,
  });
}

/* 搜索电子书 */
export function searchBook (data) {
  return request({
    url: API.serach,
    method: 'get',
    params: data,
  });
}

/* 获取专题电子书列表 */
export function bookListBySpecil (data) {
  return request({
    url: API.bookListBySpecil,
    method: 'get',
    params: data,
  });
}

/* 新品推荐 */
export function newBooks (data) {
  return request({
    url: API.newBooks,
    method: 'get',
    params: data,
  });
}

/* 查询字典数据 */
export function dicList (data) {
  return request({
    url: API.dicList,
    method: 'get',
    params: data,
  });
}

/* 点击top */
export function topClick (data) {
  return request({
    url: API.topClick,
    method: 'get',
    params: data,
  });
}

/* 用户阅读 */
export function userRead (data) {
  return request({
    url: API.userRead,
    method: 'get',
    params: data,
  });
}

/* 阅读心跳 */
export function readHeart ({ bookId, catalogueId, speedOfProgress }) {
  return request({
    url: API.readHeart,
    method: 'get',
    params: {
      bookId,
      catalogueId,
      speedOfProgress
    },
  });
}

/* 完播接口 */
export function overRead (catalogueId) {
  return request({
    url: API.overRead,
    method: 'get',
    params: {
      catalogueId,
    },
  });
}

/* 电子书时间跨度 */
export function yearRange (data) {
  return request({
    url: API.yearRange,
    method: 'get',
    params: data,
  });
}

/* 播放列表 */
export function playList (data) {
  return request({
    url: API.playList,
    method: 'get',
    params: data,
  });
}

/* 获取章节信息 */
export function getBookCatalogueInfo (data) {
  return request({
    url: API.getBookCatalogueInfo,
    method: 'get',
    params: data,
  });
}

/* 获取资源数量 */
export function getBookCountByType (data) {
  return request({
    url: API.getBookCountByType,
    method: 'get',
    params: data,
  });
}

/* 获取资源数量 */
export function getCountBookApi (data) {
  return request({
    url: API.getCountBook,
    method: 'get',
    params: data,
  });
}

// 点击次数统计
export function savePaperBookLink (data) {
  return request({
    url: '/webApi/book/savePaperBookLink',
    method: 'get',
    params: data,
  });
}

// 添加统计记录
export function addBookRecordApi (data) {
  if (!store.state.userInfo || !(store.state.userInfo && store.state.userInfo.userId)) {
    return ''
  }
  return request({
    url: API.addBookRecordApi,
    method: 'get',
    params: data,
  });
}

/* 获取专题列表 */
export function getSpecialSubjectSearchList (data) {
  return request({
    url: API.getSpecialSubjectSearchList,
    method: 'get',
    params: data,
  });
}

